import build from './version';

// Chequea si hay una versión más nueva desplegada que la que está corriendo y,
// de ser así, limpia el service worker + cachés y recarga para traer el build nuevo.
//
// Por qué se pide a la RED: el service worker sirve cache-first, así que el JS que
// corre (y su version.js) es el viejo. La única forma de saber si hay algo nuevo es
// preguntarle al servidor por version.json saltándose la caché, y comparar el hash.

const RELOAD_GUARD = 'oss_update_reloaded_for'; // evita loops de recarga

async function forceUpdate() {
    try {
        if ('serviceWorker' in navigator) {
            const regs = await navigator.serviceWorker.getRegistrations();
            await Promise.all(regs.map((r) => r.unregister()));
        }
        if (window.caches) {
            const keys = await caches.keys();
            await Promise.all(keys.map((k) => caches.delete(k)));
        }
    } catch (e) { /* si algo falla igual recargamos */ }
    window.location.reload();
}

export async function checkForUpdate() {
    // en desarrollo no forzamos nada
    if (!build.hash || build.hash === 'dev' || build.hash === 'local') {
        return;
    }
    try {
        // ?ts= + no-store para saltarse tanto el service worker como el cache HTTP
        const res = await fetch('/version.json?ts=' + Date.now(), { cache: 'no-store' });
        if (!res.ok) {
            return;
        }
        const latest = await res.json();

        // guarda el build corriendo (referencia / debug)
        try { localStorage.setItem('oss_build', JSON.stringify(build)); } catch (e) { /* noop */ }

        // al día
        if (!latest.hash || latest.hash === build.hash) {
            return;
        }

        // hay un deploy más nuevo. Evita recargar en bucle por el mismo hash.
        if (sessionStorage.getItem(RELOAD_GUARD) === latest.hash) {
            return;
        }
        sessionStorage.setItem(RELOAD_GUARD, latest.hash);

        // eslint-disable-next-line no-console
        console.log('OSS: nueva versión detectada (' + latest.hash + '), actualizando…');
        forceUpdate();
    } catch (e) {
        // silencioso: si el chequeo falla, seguimos con lo que hay
    }
}

// Chequea al arrancar y cada vez que la pestaña/app vuelve a estar visible
// (cubre el caso "vuelvo a entrar a la PWA").
export function initUpdateChecker() {
    checkForUpdate();
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            checkForUpdate();
        }
    });
}



// WEBPACK FOOTER //
// ./src/updateChecker.js